function productCardTouch() {
    const prods = document.body.querySelectorAll(".product-card a");
    if(prods.length) {
        let currentProd;
        prods.forEach(prod => {
            if(prod.querySelectorAll(".product-card__image").length > 1) {   
                prod.dataset.imageSwitched = 0;
                prod.addEventListener("click", (evt) => {
                    const self = evt.currentTarget;
                    if(parseInt(self.dataset.imageSwitched, 10) === 0) {
                        self.dataset.imageSwitched = 1;
                        self.querySelector(".product-card__image--primary").style.opacity = 0;
                        const secondary = self.querySelector(".product-card__image--secondary");
                        secondary.style.display = 'block';
                        secondary.style.opacity = 1;
                        if(currentProd) {
                            currentProd.dataset.imageSwitched = 0;
                            currentProd.querySelector(".product-card__image--primary").style.opacity = 1;
                            currentProd.querySelector(".product-card__image--secondary").style.opacity = 0;
                        }
                        currentProd = self;
                        evt.preventDefault();
                    }
                });
            }
        })
    }
}

window.addEventListener('touchstart', function onFirstTouch() {
    document.body.classList.add('touch-device');
    productCardTouch();
    window.removeEventListener('touchstart', onFirstTouch, false);
}, false);